import { useField } from 'formik';
import {
  FormikAutoAddress,
  FormikField,
  FormikIndustry,
} from '@components/formik';
import { Typography } from '@mui/material';
import ObTooltip from './ObTooltip';

const CorpBusinessDetails: React.FC = () => {
  const [meta] = useField('home');
  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom>
        Tell us more about your business
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        {import.meta.env.VITE_SITE} collects this information to better
        understand and serve your business.
      </Typography>

      <ObTooltip title="The name you provide must exactly match the name associated with your business number (BN).">
        <FormikField
          name="businessName"
          label="Legal business name"
          placeholder="Company, Inc."
        />
      </ObTooltip>

      <FormikField
        name="businessNumber"
        label="Business number (BN) or Québec Enterprise Number (NEQ)"
        placeholder="123456789"
        allowType="number"
        limitChars={30}
      />

      <ObTooltip title="The operating name of your company, if it’s different than the legal name.">
        <FormikField
          name="businessDoing"
          label="Doing business as (Optional)"
        />
      </ObTooltip>

      <FormikAutoAddress
        label="Registered business address"
        region={meta.value.toLowerCase()}
      />

      {/* <FormikCountry
        name="home"
        label="Registered business address"
        maxHeight={220}
      />

      <FormikField name="address" placeholder="Address line 1" />

      <FormikField name="address2" placeholder="Address line 2" />

      <FormikField name="city" placeholder="City" />

      <FormikField name="province" select>
        <MenuItem value="ontario">Ontario</MenuItem>
        <MenuItem value="quebec">Quebec</MenuItem>
        <MenuItem value="nova scotia">Nova Scotia</MenuItem>
      </FormikField>

      <FormikField name="postal" placeholder="Postal code" /> */}

      <FormikIndustry name="industry" label="Industry" />

      <ObTooltip
        title="If you don’t have a website, enter a social media page, LinkedIn, or
        other relevant link."
      >
        <FormikField
          name="website"
          label="Business website"
          placeholder="https://example.com"
        />
      </ObTooltip>

      <ObTooltip title="Provide a 1-2 sentence description. Make sure to note when you typically charge your customers (i.e. during checkout or 3 days later). This helps us better understand your business.">
        <FormikField
          name="description"
          label="Product description"
          placeholder="Describe your product or service"
          multiline
          rows={3}
        />
      </ObTooltip>
    </>
  );
};

export default CorpBusinessDetails;
